export default __webpack_public_path__ + "static/media/triwow.2d068464.png";